<app-enrichment-list></app-enrichment-list>
